import React from 'react';
import { Button, Col, Row, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import FacilityGroupArea from './facilityGroupArea';
import TextInput from '../../common/controls/textInput';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
import Icon from '../../common/containers/icon';
const confirmOnRemoveFields = ['name', 'facilityGroupAreas'];
const FacilityGroup = ({
  facilityGroup,
  index,
  onAdd,
  onChange,
  onRemove
}) => {
  const facilityGroupAreas = facilityGroup.facilityGroupAreas || [];
  const handleAdd = value => onAdd(`facilityGroups[${index}]/facilityGroupAreas`, value);
  const handleChange = (name, value) => onChange(index, name, value);
  const removeFacilityGroup = () => removeItemWithConfirm(facilityGroup, 'Facility Group', confirmOnRemoveFields, onRemove.bind(null, index));

  // methods for child facilityGroupArea
  const addFacilityGroupArea = () => handleAdd({
    facilityGroupID: facilityGroup.id
  });
  const changeFacilityGroupArea = (fgaIndex, name, value) => handleChange(`facilityGroupAreas[${fgaIndex}]/${name}`, value);
  const removeFacilityGroupArea = fgaIndex => {
    const newFacilityGroupAreas = JSON.parse(JSON.stringify(facilityGroupAreas));
    newFacilityGroupAreas.splice(fgaIndex, 1);
    handleChange('facilityGroupAreas', newFacilityGroupAreas);
  };
  const facilityGroupAreaComponents = facilityGroupAreas.map((nextFGA, fgaIndex) => /*#__PURE__*/React.createElement(FacilityGroupArea, {
    facilityGroupArea: nextFGA,
    key: nextFGA.id,
    index: fgaIndex,
    onChange: changeFacilityGroupArea,
    onRemove: removeFacilityGroupArea
  }));
  return /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 8,
      offset: 1
    }
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: "Group Name",
    field: "name",
    data: facilityGroup,
    onChange: handleChange,
    entity: "FacilityGroup"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "form-control t-fg-remove-group tqc-control",
    onClick: removeFacilityGroup
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Group"))), facilityGroupAreaComponents, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: {
      size: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Label, null, "\xA0"), /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    className: "form-control t-fg-add-area tqc-control",
    onClick: addFacilityGroupArea
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "plus"
  }), " New Area"))));
};
FacilityGroup.propTypes = {
  facilityGroup: PropTypes.shape({
    id: PropTypes.string,
    facilityGroupAreas: PropTypes.arrayOf(PropTypes.shape({}))
  }).isRequired,
  index: PropTypes.number.isRequired,
  onAdd: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired
};
export default FacilityGroup;